import { render } from "./MessagesDetails.vue?vue&type=template&id=47b75bf4&scoped=true"
import script from "./MessagesDetails.vue?vue&type=script&lang=js"
export * from "./MessagesDetails.vue?vue&type=script&lang=js"

import "./MessagesDetails.vue?vue&type=style&index=0&id=47b75bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b75bf4"]])

export default __exports__